import { defineComponent as _defineComponent } from 'vue'
import { sprintf } from 'sprintf-js';
import {
  watch, ref, computed, PropType,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AmountField',
  props: {
  value: { type: [Number, undefined] as PropType<number|undefined>, required: true },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const amtToCents = (val: string) => (val.match(/^\d+\.?\d?\d?$/) ? Math.round(parseFloat(val) * 100) : NaN);
const centsToAmt = (val: number | undefined) => {
  if (val === 0) { return '0'; }
  return val !== undefined ? sprintf('%.2f', val / 100) : '';
};

const amount = ref(centsToAmt(props.value));
const convertedAmount = computed(() => amtToCents(amount.value));

const priceChanged = (val: string) => {
  amount.value = val.replaceAll(',', '.');
  if (!Number.isNaN(convertedAmount.value)) {
    emit('input', convertedAmount.value);
  }
};

watch(() => props.value, () => {
  if (props.value && props.value === convertedAmount.value) {
    return;
  }
  amount.value = centsToAmt(props.value);
});


return { __sfc: true,props, emit, amtToCents, centsToAmt, amount, convertedAmount, priceChanged }
}

})